import { Action } from '@ngrx/store'
import * as MemberActions from '../../modules/member/member.actions'

export const CTA_AAA = () => $localize`Please call AAA for additional assistance:`
export const CTA_RAP = () => $localize`Please try again or contact support for assistance:`

export const getMemberNoMatchesMessage = (isRap = false): string =>
  `${ERROR_RETRIEVE_MEMBER(isRap)} ${isRap ? CTA_RAP() : CTA_AAA()}`

export const ERROR_RETRIEVE_MEMBER = (isRap = false) => isRap ?
  $localize`An error occurred while trying to retrieve your information.` :
  $localize`An error occurred while trying to retrieve your member information.`

const ERROR_REMOVE_VEHICLE = () => $localize`An error occurred while trying to remove this vehicle.`

const buildErrorMessage = (error: string, isRap: boolean): string =>
  `<p>${error}<br/>${isRap ? CTA_RAP() : CTA_AAA()}</p>`

// TODO remove
export function getActionErrorMessage(action: Action, isRap = false): string | null {
  if (action.type === MemberActions.MEMBER_INFO.FAILURE) {
    return buildErrorMessage(ERROR_RETRIEVE_MEMBER(isRap), isRap)
  }
  if (action.type === MemberActions.VEHICLE_DELETE.FAILURE) {
    return buildErrorMessage(ERROR_REMOVE_VEHICLE(), isRap)
  }
  return null
}
